function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-content">
        <a href="#home" className="footer-brand">
          <span className="logo-mark" aria-hidden="true">BF</span>
          <span>The Bright Future</span>
        </a>
        <p>Holistic learning for confident, curious children.</p>
        <div className="footer-links">
          <a href="#courses">Courses</a>
          <a href="#gallery">Gallery</a>
          <a href="#knowledge">Knowledge</a>
          <a href="#health-guide">Health Guide</a>
          <a href="#director">Director</a>
          <a href="#faq">FAQ</a>
          <a href="#contact">Contact</a>
        </div>
        <small>© {new Date().getFullYear()} The Bright Future. All rights reserved.</small>
      </div>
    </footer>
  );
}

export default Footer;
